import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { BackupsManagement } from '../../components/admin/BackupsManagement';

export function BackupsPage() {
  return (
    <AdminLayout
      title="Sauvegardes"
      description="Gérez les sauvegardes de données"
    >
      <BackupsManagement />
    </AdminLayout>
  );
}
